import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.873 13.26a2.943 2.943 0 1 0-3.889-.227L5.79 18.225A2.945 2.945 0 0 0 2 21.046a2.943 2.943 0 1 0 4.816-2.271l5.113-5.113a2.934 2.934 0 0 0 1.944.11l3.355 4.881a2.943 2.943 0 1 0 3.588.122l5.113-5.113a2.943 2.943 0 1 0-.945-.63l-5.194 5.194a2.945 2.945 0 0 0-1.534-.043l-3.383-4.923Zm-1.816-.487a1.83 1.83 0 1 0 0-3.66 1.83 1.83 0 0 0 0 3.66ZM4.943 22.875a1.83 1.83 0 1 0 0-3.66 1.83 1.83 0 0 0 0 3.66Zm23.943-11.932a1.83 1.83 0 1 1-3.659 0 1.83 1.83 0 0 1 3.66 0Zm-9.943 11.932a1.83 1.83 0 1 0 0-3.659 1.83 1.83 0 0 0 0 3.659Z",
    fill: "currentColor"
  }));
};

var SvgAnalyticsPlus = styled(SvgComponent).withConfig({
  displayName: "AnalyticsPlus__SvgAnalyticsPlus",
  componentId: "sc-1q24tlk-0"
})(["", " ", ""], size, color);
export default SvgAnalyticsPlus;